export const ADD_CONTACT_DIRECTORY = {
  HOSPITAL_NAME: "hospitalName",
  TYPE: "type",
  ADDRESS: "address",
  SPECIALTIES: "specialties",
  CONTACT_NUMBER: "contactNumber",
  EMAIL: "email",
};

// export const TYPES = [
//   { label: "Nurse", value: "Nurse" },
//   { label: "Frontdesk", value: "Frontdesk" },
//   { label: "Pharmacist", value: "Pharmacist" },
//   { label: "Supplier", value: "Supplier" },
//   { label: "Voluntier", value: "Voluntier" },
//   { label: "Medical Explorer", value: "Medical Explorer" },
// ];


